import styled, { css } from 'styled-components';

export const ModalContainer = styled.div<{ overAll: boolean; isOpen: boolean }>`
  align-items: center;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: center;
  left: 0;
  min-height: 100%;
  position: fixed;
  top: 0;
  transition: all ${({ theme }) => theme.modal.animationDuration}ms;
  visibility: ${({ isOpen }) => !isOpen && 'hidden'};
  width: 100%;
  z-index: ${({ overAll, theme }) => (overAll ? theme.layers.topLayer : theme.layers.mediumLayer)};
  ${({ isOpen }) =>
    isOpen &&
    css`
      background-color: rgba(0, 0, 0, 0.5294117647);
    `}
`;
export const ModalView = styled.div<{
  width: string;
  height: string;
  isOpen: boolean;
}>`
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 5px 13px rgb(0 0 0 / 29%);
  box-sizing: border-box;
  height: ${({ height }) => height};
  opacity: 0;
  padding: ${({ theme }) => theme.modal.padding}px;
  margin: 0 16px;
  position: relative;
  transition: all ${({ theme }) => theme.modal.animationDuration}ms;
  width: ${({ width }) => width};
  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      visibility: visible;
    `}
  ${({ isOpen }) =>
    !isOpen &&
    css`
      transform: scale(2);
    `}
`;

export const Icon = styled.div`
  cursor: pointer;
  position: absolute;
  right: ${({ theme }) => theme.modal.padding}px;
  top: ${({ theme }) => theme.modal.padding}px;
  z-index: ${({ theme }) => theme.layers.baseLayer + 1};
`;
